import React, { useEffect, useState } from "react"
import Select from "react-select"

import MetaTags from "react-meta-tags"
import {
  Table,
  CardTitle,
  CardSubtitle,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { formValidation, mapDataForDropDown } from "helpers/helpers"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { apiError } from "store/actions"
import FieldValidation from "../../../components/Common/FieldValidation"
import { getAllAcca7Call } from "helpers/repository"
import { updateAcca7 } from "store/Acca7/actions"
import {sitename} from "../../../constants/constants";
const Edit = props => {
  const urlParams = new URLSearchParams(props.location.search)

  const dispatch = useDispatch()
  const [is_active, set_is_active] = useState(false)
  const [percentages, set_percentages] = useState([])
  const [start_date, set_start_date] = useState("")
  const [end_date, set_end_date] = useState("")
  const [constant, set_constant] = useState(0)
  const [percentagesError, set_percentagesError] = useState(null)

  useEffect(() => {
  
    getAllAcca7Call().then(res => {
      let obj = res.data.data.filter(bn => bn["id"] == urlParams.get("id"))
      obj = obj.length > 0 ? obj[0] : {}
      let percentage = JSON.parse(obj["bonus_condition"]);

      percentage.forEach(function(e, index){
        if(index == 0) {
          e['can_add'] =  1
          e['can_delete'] = 0
        } else {
          e['can_add'] =  0
          e['can_delete'] = 1
        }
      });
      set_percentages(percentage)
      set_start_date(obj["start_date"])
      set_end_date(obj["end_date"])
      set_is_active(obj?.is_active)
    })
  }, [])

  const handleSubmit = e => {
    e.preventDefault()
    let new_percentages = percentages.map(({ can_add,can_delete, ...item }) => item);

    const number_of_match_per_ticket = new_percentages.map(item => item.number_of_match_per_ticket);
    const result = number_of_match_per_ticket.filter(checkParam);
   
    if(result.length == number_of_match_per_ticket.length) {
      
      set_percentagesError(null);
      const data = {
        id: urlParams.get("id"),
        start_date: start_date,
        end_date: end_date,
        bonus_condition: new_percentages,
        is_active: is_active,
      }
      dispatch(updateAcca7(data, props.history))
    } else {
      set_percentagesError('Number of Match Per Ticket Should not be empty and value should be like x/x-y/x+')
      return false;
    }

  }
  const formErrors = useSelector(state => state?.CommonState)

  const CreateRow = (can_add, can_delete, count, is_first_time = 0) => {

    let percentage = percentages;
    if((!percentage.length && is_first_time) || (percentage.length && !is_first_time)) {

      let number_of_match_per_ticket = '';
      if(!percentage.length) {
        number_of_match_per_ticket = '0-'
      } else {
        let data = percentage[percentage.length - 1]['number_of_match_per_ticket'];
        if(data.includes('-')) {
            let range = data.split("-");
            number_of_match_per_ticket = (!isNaN(+parseInt(range[1]))) ? (parseInt(range[1]) + 1) + '-' : '';
        }
      }
      percentage.push({
        number_of_match_per_ticket: number_of_match_per_ticket, 
        lost_match_count: 0, 
        stake_back_multiplier_value: 1,
        min_total_odds: 1,
        can_add: can_add,
        can_delete: can_delete,
       }); 
    }

    set_percentages(percentage);
    set_constant((count) ? 0 : 1);
  };

  const DeleteRow = (index, count) => {
    let percentage = percentages;
    percentage.splice(index, 1);
    set_percentages(percentage);
    set_constant((count) ? 0 : 1);
  };

  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }

  const handleOnChange = (index, value, field, count) => {
    let percentage = percentages;
    percentage[index][field] = value;
    set_percentages(percentage);
    set_constant((count) ? 0 : 1);
  };

  const getRows = (row, index) => {
    return (
      <>
        <div className="row mb-4">
          <Col lg={3}>
            <input
              className="form-control"
              type="text"
              placeholder="0-10 or 10+ or 10"
              onChange={(e) => {
                  const re = /^[0-9-+\b]+$/;
                  // if value is not blank, then test the regex
                  if (e.target.value === '' || re.test(e.target.value)) {
                    handleOnChange(index, e.target.value, 'number_of_match_per_ticket', constant)
                  }
              }}
              value={row.number_of_match_per_ticket}      
            />
          </Col>
          <Col lg={2}>
            <input
              className="form-control"
              type="number"
              step='1'
              min='0'
              onChange={(e) => {
                handleOnChange(index, e.target.value, 'lost_match_count', constant)
              }}
              value={row.lost_match_count}
            />
          </Col>
          <Col lg={2}>
            <input
              className="form-control"
              type="number"
              step='0.1'
              min='0.1'
              onChange={(e) => {
                handleOnChange(index, e.target.value, 'stake_back_multiplier_value', constant)
              }}
              value={row.stake_back_multiplier_value}
            />
          </Col>
          <Col lg={3}>
            <input
              className="form-control"
              type="number"
              step='0.01'
              min='1'
              onChange={(e) => {
                handleOnChange(index, e.target.value, 'min_total_odds', constant)
              }}
              value={row.min_total_odds}
            />
          </Col>
          {((row.can_add) ?
            <Col lg={1}>
              <button
              type="button"
              className="btn btn-sm px-3 font-size-16"
              onClick={() => {
                CreateRow(0,1,constant);
              }}
            >
              <i className="fa fa-fw fa-plus" />
            </button>
            </Col> : (row.can_delete) ?
            <Col lg={1}>
              <button
              type="button"
              className="btn btn-sm px-3 font-size-16"
              onClick={() => {
                DeleteRow(index, constant);
              }}
            >
              <i className="fa fa-fw fa-minus" />
            </button>
            </Col> : null
            )
          }
        </div>
      </>
    )
  }

  function checkParam(number_of_match_per_ticket) {
    let reg = /^((\d+[\-]?\d+)|(\d+[\+]))$/;
    let result = reg.test(number_of_match_per_ticket);
    if(result) {
        return number_of_match_per_ticket;
    }
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Bonuses" breadcrumbItem="Edit" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
            Acca7 Information Form
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <Col lg={12}>
                    <Card className="mb-0">
                      <CardBody>
                        <div className="row">
                          <Col lg={3}>
                            <label className="form-label">Start Date</label>
                            <input
                              className="form-control"
                              type="date"
                              onChange={e => {
                                removeError("start_date")
                                set_start_date(e.target.value)
                              }}
                              value={start_date}
                            />
                            {formErrors?.start_date ? (
                              <FieldValidation errorMessage={formErrors?.start_date} />
                            ) : null}
                          </Col>
                          <Col lg={3}>
                            <label className="form-label">End Date</label>
                            <input
                              className="form-control"
                              type="date"
                              onChange={e => {
                                removeError("end_date")
                                set_end_date(e.target.value)
                              }}
                              value={end_date}
                            />
                            {formErrors?.end_date ? (
                              <FieldValidation errorMessage={formErrors?.end_date} />
                            ) : null}
                          </Col>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  
                  <Col lg={12}>
                    <Card>
                      <CardBody>
                        <CardTitle>Bonus Condition</CardTitle>
                        <div className="row mb-4">   
                          <div className="row mt-3" >
                            <Col lg={3}>
                              <label className="form-label bold">Number of Matches Per Ticket</label>
                            </Col>
                            <Col lg={2}>
                              <label className="form-label">Lost Match Count</label>
                            </Col>
                            <Col lg={2}>
                              <label className="form-label">Stake Back Multiplier Value</label>
                            </Col>
                            <Col lg={3}>
                              <label className="form-label">Minimum Total Odds</label>
                            </Col>
                            <Col lg={2}>
                              <label className="form-label">Action</label>
                            </Col>
                          </div>                 
                          {
                          (constant >= 0) ?  
                          percentages.map((row, i) => {
                            return (
                              <>
                                {getRows(row, i)}
                              </>
                            )
                          }) : null}
                        </div>
                        {percentagesError ? (
                              <FieldValidation errorMessage={percentagesError} />
                            ) : null}
                      </CardBody>
                    </Card>
                  </Col>
                </div>
                <div className="d-flex flex-wrap gap-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="defaultCheck1"
                      onChange={() => set_is_active(!is_active)}
                      checked={is_active}
                      defaultChecked={is_active}
                    />
                    <label className="form-check-label" htmlFor="defaultCheck1">
                      Is Active?
                    </label>
                  </div>
                </div>
                <div className="d-flex flex-wrap gap-2 justify-content-end">
                  <Button type="submit" color="primary" className="">
                    Save
                  </Button>{" "}
                  <Button
                    type="reset"
                    color="secondary"
                    className=""
                    onClick={() => {
                      props.history.push("/promotions/acca7")
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const EditAcca7 = withRouter(Edit)
